import React from 'react';

import PlayerStandingsCard from '../../cards/PlayerStandingsCard';
import TeamStandingsCard from '../../cards/TeamStandingsCard';
import StandingsHeaderColumns from './StandingsHeaderColumns';
import { drawStandingsEnabled } from '../../../utils/events';
import { getApiAxiosInstance } from '../../../utils/network';
import InfoButton from '../../InfoButton';

class Standings extends React.Component {
    constructor(props) {
        super(props);
        this.fetchDrawStats = this.fetchDrawStats.bind(this);
    }

    async componentDidMount() {
        console.log('standings componentDidMount');
        await this.fetchDrawStats();
    }

    async componentDidUpdate() {
        console.log('standings componentDidUpdate');
        await this.fetchDrawStats();
    }

    async fetchDrawStats() {
        const { event, drawsTabState, stats, updateDrawStats, parsed } = this.props;
        const { selectedDraw } = drawsTabState;
        if (selectedDraw) {
            const standingsEnabled = selectedDraw.eliminationType && drawStandingsEnabled(selectedDraw.eliminationType.value);
            if (standingsEnabled && (!stats[selectedDraw.id] || (stats[selectedDraw.id] != null && !stats[selectedDraw.id].loading && !stats[selectedDraw.id].data))) {
                // fetch draw stats
                stats[selectedDraw.id] = { loading: true, data: null };
                updateDrawStats({ stats });
                // for embedded web view
                const { jwt } = parsed;
                const axiosInstance = getApiAxiosInstance(jwt);

                // TODO: refactor to use redux
                const response = await axiosInstance.get(`v1/tms/events/${event.id}/draws/${selectedDraw.id}/stats`);
                stats[selectedDraw.id] = {
                    data: response.data,
                    loading: false,
                };
                updateDrawStats({ stats });
            }
        }
    }

    render() {
        const {
            playersDict,
            teamsDict,
            drawStandings,
            drawStandingsLoading,
            event,
        } = this.props;
        const { sportTypeId } = event || {};

        const standingsData = drawStandings && (drawStandings.playerStats || drawStandings.teamStats);

        if (drawStandingsLoading) {
            return <div>Loading Stats</div>;
        }
        if (!standingsData) {
            return <div>No Stats For Draw</div>;
        }

        return (
            <div className={``}>
                <div className="text-right">How is rank order determined?
                    <InfoButton
                        alignRight={true}
                        hoverText={(
                            <React.Fragment>
                                Rank order in the standings is determined by
                                <ol>
                                    <li>Greatest Number of Wins</li>
                                    <li>Head to Head result if only two players are tied</li>
                                    <li>% of sets won</li>
                                    <li>% of games won</li>
                                    <li>Overall Current</li>
                                </ol>
                            </React.Fragment>
                        )}
                    />
                </div>
                <StandingsHeaderColumns />
                {drawStandings.playerStats && standingsData
                    .filter(standing => playersDict[standing.id] !== null)
                    .map((standing) => {
                        return (
                            <PlayerStandingsCard
                                key={standing.id}
                                player={playersDict[standing.id]}
                                stats={standing.stats}
                                sportTypeId={sportTypeId}
                            />
                        );
                    })}
                {drawStandings.teamStats && standingsData.map((standing) => {
                    const teamPlayers = teamsDict[standing.teamId].players.map(playerId => {
                        return playersDict[playerId];
                    });

                    return (
                        <TeamStandingsCard
                            key={standing.teamId}
                            team={teamsDict[standing.teamId]}
                            teamPlayers={teamPlayers}
                            stats={standing.stats}
                            sportTypeId={sportTypeId}
                        />
                    );
                })}
            </div>
        );
    }
}

export default Standings;
